module.exports = __webpack_public_path__ + "img/1429004408.7be44cfc.jpg";